/** @format */

export enum TransactionVariant {
    CASH_PURCHASE = 'CASH_PURCHASE',
    PART_EXCHANGE = 'PART_EXCHANGE',
    PART_REFUND = 'PART_REFUND',
    ORDER = 'ORDER',
    NOT_FOUND = 'NOT_FOUND',
    RETURN = 'RETURN',
}

export enum PromotionSummaryType {
    UNDEFINED = 'UNDEFINED',
    DISCOUNT = 'DISCOUNT',
    BONUS = 'BONUS',
    SHIPMENT = 'SHIPMENT',
    COLLECTION = 'COLLECTION',
}
